const translation = {
  daysInWeek: {
    Sun: 'Soare',
    Thu: 'Joia',
    Wed: 'Miercuri',
    Tue: 'Marți',
    Sat: 'Sat',
    Mon: 'Mon',
    Fri: 'Vineri',
  },
  months: {
    December: 'Decembrie',
    February: 'Februarie',
    April: 'Aprilie',
    August: 'August',
    September: 'septembrie',
    March: 'Martie',
    May: 'Mai',
    July: 'Iulie',
    June: 'Iunie',
    October: 'Octombrie',
    November: 'Noiembrie',
    January: 'ianuarie',
  },
  operation: {
    cancel: 'Anulează',
    pickDate: 'Alege o dată',
    now: 'Acum',
    ok: 'Bine',
  },
  title: {
    pickTime: 'Alegeți timpul',
  },
  defaultPlaceholder: 'Alege o oră...',
}

export default translation
